export default {"src":"/_next/static/media/linkedin.d1cc7c58.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};